import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { deepExtract } from 'helpers/deep';
import { isPresent } from 'helpers/verify';
export var SET_OPEN_PANEL = 'classpass/searchbox/SET_OPEN_PANEL';
export var CLOSE_OPEN_PANEL = 'classpass/searchbox/CLOSE_OPEN_PANEL';
export var CLEAR_KEYWORD = 'classpass/searchbox/CLEAR_KEYWORD';
export var CLEAR_LOCATION = 'classpass/searchbox/CLEAR_LOCATION';
export var SET_KEYWORD_VALUE = 'classpass/searchbox/SET_KEYWORD_VALUE';
export var SET_LOCATION_VALUE = 'classpass/searchbox/SET_LOCATION_VALUE';
export var SET_DEFAULT_LOCATION = 'classpass/searchbox/SET_DEFAULT_LOCATION';
export var SET_SELECTED_LOCATION = 'classpass/searchbox/SET_SELECTED_LOCATION';
var SET_KEYWORD_KEY = 'classpass/searchbox/SET_KEYWORD_KEY';
var SET_LOCATION_KEY = 'classpass/searchbox/SET_LOCATION_KEY';
export var SET_KEYWORD = 'classpass/searchbox/SET_KEYWORD';
var SET_LOCATION_TIMEZONE = 'classpass/searchbox/SET_LOCATION_TIMEZONE';
export var closeOpenPanel = function closeOpenPanel() {
  return {
    type: CLOSE_OPEN_PANEL,
    key: 'openPanel',
    value: null
  };
};
export var setOpenPanel = function setOpenPanel(value) {
  return {
    type: SET_OPEN_PANEL,
    key: 'openPanel',
    value: value
  };
};
export var setKeywordFieldValue = function setKeywordFieldValue(value) {
  return {
    type: SET_KEYWORD_VALUE,
    key: 'keywordFieldValue',
    value: value
  };
};
export var setKeyword = function setKeyword(value) {
  return {
    type: SET_KEYWORD,
    value: value
  };
};
export var setKeywordKey = function setKeywordKey(value) {
  return {
    type: SET_KEYWORD_KEY,
    key: 'keywordKey',
    value: value
  };
};
export var clearKeywordField = function clearKeywordField() {
  return {
    type: CLEAR_KEYWORD
  };
};
export var setLocationFieldValue = function setLocationFieldValue(value) {
  return {
    type: SET_LOCATION_VALUE,
    value: value,
    key: 'locationFieldValue'
  };
};
export var setLocationKey = function setLocationKey(value) {
  return {
    type: SET_LOCATION_KEY,
    key: 'locationKey',
    value: value
  };
};
export var setDefaultLocation = function setDefaultLocation(location) {
  return {
    type: SET_DEFAULT_LOCATION,
    location: location
  };
};
export var setSelectedLocation = function setSelectedLocation(location) {
  return {
    type: SET_SELECTED_LOCATION,
    location: location
  };
};
export var setLocationTimezone = function setLocationTimezone(value) {
  return {
    type: SET_LOCATION_TIMEZONE,
    value: value
  };
};
export var clearLocationField = function clearLocationField() {
  return {
    type: CLEAR_LOCATION
  };
};
export var selectSearchBoxState = function selectSearchBoxState(state) {
  return state.features.searchBox || {};
};
export var selectOpenPanel = function selectOpenPanel(state) {
  return selectSearchBoxState(state).openPanel;
};
export var selectSelectedKeywordId = function selectSelectedKeywordId(state) {
  return selectSearchBoxState(state).keywordSelectedId;
};
export var selectDefaultLocation = function selectDefaultLocation(state) {
  return selectSearchBoxState(state).defaultLocation;
};
export var selectSelectedLocation = function selectSelectedLocation(state) {
  return selectSearchBoxState(state).selectedLocation;
};
export var selectPreviousLocation = function selectPreviousLocation(state) {
  return selectSearchBoxState(state).previousLocation;
};
export var selectActiveLocation = function selectActiveLocation(state) {
  return selectSelectedLocation(state) || selectDefaultLocation(state);
};
export var selectKeywordSearchBoxText = function selectKeywordSearchBoxText(state) {
  return selectSearchBoxState(state).keywordDisplayValue;
};
export var selectKeywordOriginalValue = function selectKeywordOriginalValue(state) {
  return selectSearchBoxState(state).keywordOriginalValue;
};
export var selectLocationSearchBoxText = function selectLocationSearchBoxText(state) {
  var _selectSearchBoxState = selectSearchBoxState(state),
      selectedLocation = _selectSearchBoxState.selectedLocation,
      defaultLocation = _selectSearchBoxState.defaultLocation;

  return deepExtract('locationName', selectedLocation || defaultLocation, '');
};
var initialState = {
  keywordKey: '',
  keywordFieldValue: '',
  keywordDisplayValue: '',
  keywordSelectedId: '',
  locationFieldValue: '',
  locationKey: '',
  openPanel: null,
  selectedLocation: null,
  defaultLocation: null,
  previousLocation: null
};
export function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case CLOSE_OPEN_PANEL:
    case SET_OPEN_PANEL:
    case SET_KEYWORD_KEY:
    case SET_KEYWORD_VALUE:
    case SET_LOCATION_KEY:
    case SET_LOCATION_VALUE:
      return _objectSpread({}, state, _defineProperty({}, action.key, action.value));

    case SET_KEYWORD:
      return _objectSpread({}, state, {
        keywordDisplayValue: action.value.name,
        keywordSelectedId: action.value.id,
        keywordOriginalValue: deepExtract('value.analytics_metadata.synonym_original_name', action)
      });

    case SET_DEFAULT_LOCATION:
      return _objectSpread({}, state, {
        defaultLocation: _objectSpread({}, action.location, {
          isMapSearch: isPresent(deepExtract('location.mapBounds', action, null))
        })
      });

    case SET_SELECTED_LOCATION:
      return _objectSpread({}, state, {
        previousLocation: _objectSpread({}, state.selectedLocation || {}),
        selectedLocation: _objectSpread({}, action.location, {
          isMapSearch: isPresent(deepExtract('location.mapBounds', action, null))
        })
      });

    case SET_LOCATION_TIMEZONE:
      return _objectSpread({}, state, {
        selectedLocation: _objectSpread({}, state.selectedLocation, {
          timezone: action.value
        })
      });

    case CLEAR_KEYWORD:
      return _objectSpread({}, state, {
        keywordDisplayValue: '',
        keywordFieldValue: '',
        keywordSelectedId: ''
      });

    case CLEAR_LOCATION:
      return _objectSpread({}, state, {
        previousLocation: _objectSpread({}, state.selectedLocation || {}),
        locationFieldValue: '',
        selectedLocation: null
      });

    default:
      return state;
  }
}